import { requiredFalse } from 'ngrx-forms/validation';
import { BuildValidatorDecorator } from './helpers';

export const RequiredFalse = BuildValidatorDecorator(requiredFalse, 'DX.FORMS.VALIDATION.ERRORS.REQUIRED_FALSE');
